module.exports = __webpack_public_path__ + "img/icon-28.aaade0d1.png";